var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrowLeftAndRight = function SvgArrowLeftAndRight(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "arrow_left_and_right_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#arrow_left_and_right_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#414A5F",
    d: "m6.373 16.596 1.323 1.323q.208.208.213.515a.73.73 0 0 1-.23.541.72.72 0 0 1-.525.215.72.72 0 0 1-.527-.217l-2.491-2.49a.84.84 0 0 1-.26-.638q.001-.18.059-.335a.8.8 0 0 1 .201-.3l2.49-2.49a.72.72 0 0 1 .515-.213.75.75 0 0 1 .54.21.74.74 0 0 1 .232.537q0 .302-.232.535l-1.308 1.307h4.483q.318 0 .534.216a.73.73 0 0 1 .216.535q0 .318-.216.534a.73.73 0 0 1-.534.215zm8.031.048a.77.77 0 0 1-.569-.229.77.77 0 0 1-.23-.568q0-.34.23-.569a.77.77 0 0 1 .568-.23q.339 0 .57.23a.77.77 0 0 1 .229.568.77.77 0 0 1-.23.569.77.77 0 0 1-.567.23m3.596 0a.77.77 0 0 1-.568-.229.77.77 0 0 1-.23-.568q0-.34.23-.569a.77.77 0 0 1 .568-.23q.339 0 .568.23a.77.77 0 0 1 .23.568.77.77 0 0 1-.23.569.77.77 0 0 1-.568.23m-.363-7.74h-4.493a.73.73 0 0 1-.534-.216.73.73 0 0 1-.216-.534q0-.32.216-.535a.73.73 0 0 1 .534-.215h4.483l-1.323-1.323a.72.72 0 0 1-.213-.515.73.73 0 0 1 .23-.541.72.72 0 0 1 .525-.215q.31 0 .527.217l2.491 2.49a.84.84 0 0 1 .259.638q0 .18-.058.336a.8.8 0 0 1-.198.296l-2.504 2.504a.7.7 0 0 1-.513.207.75.75 0 0 1-.53-.207.7.7 0 0 1-.229-.535.75.75 0 0 1 .228-.535zM6 8.952a.77.77 0 0 1-.568-.23.77.77 0 0 1-.23-.568q0-.339.23-.568a.77.77 0 0 1 .567-.23q.339 0 .57.23.229.228.229.567a.77.77 0 0 1-.23.57.77.77 0 0 1-.568.23m3.597 0a.77.77 0 0 1-.57-.23.77.77 0 0 1-.229-.568q0-.339.23-.568a.77.77 0 0 1 .567-.23q.339 0 .57.23.23.228.23.567a.77.77 0 0 1-.23.57.77.77 0 0 1-.568.23"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowLeftAndRight);
export default ForwardRef;